module.exports = __webpack_public_path__ + "static/media/left-lateral-nonflexion.46825d25.png";